module.exports = __webpack_public_path__ + "img/safe_content.97142444.svg";